import React, { FC } from "react";

import { AddIconNew } from "../Icons";
import { MIXPANEL_EVENTS } from "../../config/mixPanelEvents";
import { MODALS } from "../../config/params";
import { SecondaryButton } from "../../styles/styledComponents";
import { useGTM } from "../../hooks/useGTM";
import { useModal } from "../../context/ModalContext";
import { userActivityLogger } from "../../utils/mixpanel";

const AddPetButtonAndModal: FC = () => {
  const { openModal } = useModal();
  const { dispatchEvent } = useGTM();

  const handleGoToAddAPet = () => {
    openModal(MODALS.ADD_A_PET);
    userActivityLogger(MIXPANEL_EVENTS.ADD_PET, { referred_from: "Dashboard" });
    dispatchEvent({
      eventName: "gv_add_a_pet_dashboard",
    });
  };

  return (
    <SecondaryButton
      type={"button"}
      className="grow !text-xs font-semibold !py-2 cursor-pointer"
      onClick={handleGoToAddAPet}
    >
      <AddIconNew /> Add Your Pet
    </SecondaryButton>
  );
};

export default AddPetButtonAndModal;
